import { Select, Option } from "@ingka/select";
import { AdminUserDto, UserDto, UploadWithSlimAssetsDtoStateEnum } from "generated";
import { isUploadFinalized } from "@/components/MetadataFields/formFieldsAccessRules";

const AdminDropdown = ({
  assignee,
  admins,
  onSelect,
  uploadState,
}: {
  assignee?: UserDto;
  admins: AdminUserDto[];
  onSelect: (admin: string) => void;
  uploadState: UploadWithSlimAssetsDtoStateEnum;
}) => {
  const value =
    (assignee &&
      admins.find((admin) =>
        admin.name.includes(`${assignee.firstName} ${assignee.lastName}`),
      )?.id) ||
    "";
  return (
    <Select
      id="assign"
      label="Assigned to"
      value={value}
      disabled={isUploadFinalized({ uploadState })}
      onChange={(e) => {
        onSelect(e.target.value);
      }}
    >
      {admins.map(({ id, name }) => (
        <Option key={id} name={name.split("(")[0]} value={id} />
      ))}
    </Select>
  );
};

export default AdminDropdown;
